import React from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { moderateScale } from 'react-native-size-matters';
import { getUrls } from '../../config/index';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { openInAppWebViewerInBackground } from '../../utils/inAppWebViewer';
import { ChevronRightBlackIcon } from './Icons';

const shopGearWebsite = () => {
  const { SHOP_GEAR } = getUrls();
  window.open(`${SHOP_GEAR}`);
};

const inAppShopGear = () => {
  const { SHOP_GEAR } = getUrls();
  const url = `${SHOP_GEAR}`;
  openInAppWebViewerInBackground(url);
};

const handleOnPress = async (props) => {
  props.onShopOpenPress();
  isWeb ? shopGearWebsite() : inAppShopGear()
}
const isWeb = Platform.OS === 'web';

export const ShopGearBanner = (props) => (
  <TouchableOpacity style={[styles.buttonContainer, { backgroundColor: Theme.PRIMARY }]} onPress={() => handleOnPress(props)}>
    <Text style={styles.buttonText}>{props.t('shopGear')}</Text>
      <View style={styles.arrowIcon}>
        <ChevronRightBlackIcon width={defaultScale(18)} height={defaultScale(18)} color={Theme.BLACK} />
      </View>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  buttonContainer: {
    height: defaultScale(60),
    backgroundColor: Theme.PRIMARY,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 1,
  },
  buttonText: {
    ...Theme.textStyle.heading,
    color: Theme.BLACK,
    fontFamily: Theme.Custom700,
    fontSize: moderateScale(18, 1),
  },
  arrowIcon: {
    paddingTop: defaultScale(3),
    width: defaultScale(25),
    marginLeft: defaultScale(8),
    paddingHorizontal: defaultScale(5),
    alignItems: 'center',
    justifyContent: 'center',
  },
});
